var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.417 7C13.417 9.89917 11.0662 12.25 8.16699 12.25C8.16699 11.0833 8.16699 12.25 8.16699 11.0833C11.807 11.0833 13.627 6.685 11.0545 4.1125C8.48199 1.54 4.08366 3.36583 4.08366 7H5.83366L3.50033 9.33333H3.44199L1.16699 7H2.91699C2.91699 4.10083 5.26783 1.75 8.16699 1.75C11.0662 1.75 13.417 4.10083 13.417 7Z",
    fill: "#E1292B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnReset);
export default __webpack_public_path__ + "static/media/icn_reset.e8a32e26ece941eaa64565793f44ad31.svg";
export { ForwardRef as ReactComponent };